// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { call, delay, put } from 'redux-saga/effects';
import { AuthTypes } from '../../reducer/auth';
import ApiService from '../../../../services/api';
import Cookies from 'js-cookie';
import { getAllPages } from '../admin';
import moment from 'moment';

const api = ApiService;

export function* actionConnect({ navigate }) {
  const token = Cookies.get('token');
  const expired = Cookies.get('expired');
  if (token) {
    const isExpired = moment().isAfter(moment(expired));
    if (isExpired) {
      Cookies.remove('token');
      Cookies.remove('expired');
      navigate('/login');
    } else {
      api.addAuthorizationHeader(token);
      yield call(getAllPages);
      yield put({
        type: AuthTypes.CONNECT_SUCCESS,
        payload: { isLoggedIn: true, token },
      });
    }
  } else {
    yield put({
      type: AuthTypes.CONNECT_SUCCESS,
      payload: { isLoggedIn: false, token: null },
    });
    navigate('/login');
  }
}

export function* signIn({ params, navigate }) {
  try {
    const token = yield call(api.login, params);
    if (token) {
      yield call(getAllPages);
      yield put({
        type: AuthTypes.LOGIN_SUCCESS,
        payload: {
          isLoggedIn: true,
          token,
        },
      });
      navigate('/');
    }
  } catch (ex) {
    yield put({
      type: AuthTypes.LOGIN_FAILURE,
      payload: { error: ex?.response?.data?.message || 'Sign in error' },
    });
  }
}

export function* signUp({ params, callback }) {
  try {
    delete params.confirm_password;
    yield call(api.register, params);
    const { username, password } = params;
    yield call(signIn, { params: { username, password }, callback });
    yield put({
      type: AuthTypes.SIGNUP_SUCCESS,
    });
  } catch (ex) {
    yield put({
      type: AuthTypes.SIGNUP_FAILURE,
      payload: { error: ex.data?.detail || 'Sign up error' },
    });
  }
}

export function* signOut({ navigate }) {
  yield put({ type: AuthTypes.SIGN_OUT_SUCCESS });
  Cookies.remove('token');
  Cookies.remove('expired');
  navigate('/login');
}
